// extracted by mini-css-extract-plugin
export default {"root":"_1uuRV","transform":"_1uMz2","swipeable":"_1XPon","preview":"_1hu0f","next":"_3IDHa","prev":"_1vwoC","loading":"P61sF"};